import React from 'react';
import { ArrowLeft, Scale, Gavel, Zap, Brain, MessageCircle } from 'lucide-react';
import { LAW_CONFIG } from '../../data/laws'; 

// [수정] 상단 인자값에 setSelectedStage를 추가했습니다.
export default function HomeView({ setView, setSelectedLaw, setSelectedStage, setGameModeType, isAdmin, setShowFeedbackModal, category, setCategory }) {
  
  const handleLawSelect = (law) => {
    if (Object.keys(LAW_CONFIG).includes(law)) {
      setSelectedLaw(law);
      setGameModeType('normal');
      setView('stage_select');
    }
  };

  const renderButtons = () => {
    if (category === 'admin') {
      return (
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 w-full max-w-3xl animate-fadeIn">
          {['헌법 및 헌법재판소법', '행정심판법', '행정소송법', '행정기본법', '행정절차법'].map((law) => {
            const isActive = LAW_CONFIG[law] && LAW_CONFIG[law].data && LAW_CONFIG[law].data.length > 0;
            return (
              <button key={law} onClick={() => isActive && handleLawSelect(law)} disabled={!isActive} className={`p-4 rounded-xl shadow-lg transition flex flex-col items-center justify-center min-h-[100px] border-2 ${isActive ? 'bg-slate-800 border-slate-600 hover:border-indigo-500 hover:bg-indigo-900/30' : 'bg-slate-800 border-slate-700 opacity-50'}`}>
                <Scale className={`w-8 h-8 mb-2 ${isActive ? 'text-indigo-400' : 'text-slate-500'}`} />
                <h3 className={`font-bold text-base ${isActive ? 'text-white' : 'text-slate-500'}`}>{law}</h3>
              </button>
            );
          })}
        </div>
      );
    } else if (category === 'individual') {
      return (
        <div className="grid grid-cols-2 gap-4 w-full max-w-3xl animate-fadeIn">
          {['토지보상법', '손실보상', '부동산공시법', '감정평가법'].map((law) => {
            const isActuallyActive = law === '토지보상법' || (LAW_CONFIG[law]?.data?.length > 0);
            return (
              <button key={law} onClick={() => isActuallyActive && handleLawSelect(law)} disabled={!isActuallyActive} className={`p-4 rounded-xl shadow-lg transition flex flex-col items-center justify-center min-h-[100px] border-2 ${isActuallyActive ? 'bg-slate-800 border-slate-600 hover:border-indigo-500 hover:bg-indigo-900/30' : 'bg-slate-800 border-slate-700 opacity-50'}`}>
                <Gavel className={`w-8 h-8 mb-2 ${isActuallyActive ? 'text-indigo-400' : 'text-slate-500'}`} />
                <h3 className={`font-bold text-lg ${isActuallyActive ? 'text-white' : 'text-slate-500'}`}>{law}</h3>
              </button>
            );
          })}
        </div>
      );
    } else {
      return (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full max-w-2xl animate-fadeIn">
          <button onClick={() => setCategory('admin')} className="bg-gradient-to-br from-indigo-900 to-slate-800 border-2 border-indigo-500/50 hover:border-indigo-400 p-5 rounded-2xl shadow-xl transition transform hover:scale-[1.02] group">
            <Scale className="w-12 h-12 text-indigo-300 mb-3 mx-auto group-hover:text-white transition" />
            <h3 className="font-extrabold text-xl text-white mb-1">행정법</h3>
            <p className="text-indigo-200 text-xs">헌법, 행정심판법 등 5개 법률</p>
          </button>
          <button onClick={() => setCategory('individual')} className="bg-gradient-to-br from-blue-900 to-slate-800 border-2 border-blue-500/50 hover:border-blue-400 p-5 rounded-2xl shadow-xl transition transform hover:scale-[1.02] group">
            <Gavel className="w-12 h-12 text-blue-300 mb-3 mx-auto group-hover:text-white transition" />
            <h3 className="font-extrabold text-xl text-white mb-1">개별법</h3>
            <p className="text-blue-200 text-xs">토지보상법 등 4개 법률</p>
          </button>
        </div>
      );
    }
  };

  return (
    <div className="relative p-1 min-h-[600px] flex flex-col justify-center">
      <div className="absolute inset-0 border-[6px] border-double border-amber-600/60 rounded-xl pointer-events-none"></div>
      <div className="absolute inset-2 border border-amber-500/30 rounded-lg pointer-events-none"></div>
      <div className="flex flex-col items-center justify-center space-y-6 py-10 px-4 relative z-10">
        {category && (
          <div className="w-full max-w-3xl flex justify-start absolute top-6 left-6 z-20">
            <button onClick={() => setCategory(null)} className="flex items-center bg-slate-800 hover:bg-slate-700 text-slate-300 hover:text-white px-3 py-2 rounded-lg border border-slate-600 transition shadow-md text-sm font-bold">
              <ArrowLeft className="w-4 h-4 mr-1" /> 카테고리 선택으로
            </button>
          </div>
        )}
        <div className="text-center space-y-2 mt-8">
          <h2 className="text-2xl md:text-3xl font-extrabold leading-tight">
            <span className="block text-white">도승하평가사와</span><span className="block text-white">함께하는</span><span className="block text-transparent bg-clip-text bg-gradient-to-r from-amber-200 via-amber-400 to-amber-200 animate-pulse mt-1">조문암기 연습</span>
          </h2>
          <p className="text-slate-400 font-serif italic text-sm">"오늘도 합격을 위해 달려봅시다"</p>
        </div>
        
        {renderButtons()}
        
        <div className="w-full max-w-3xl mt-4">
          <button 
            onClick={() => {
              // 1. 모든 법률 데이터 수집
              let allQuestions = [];
              Object.keys(LAW_CONFIG).forEach(key => {
                if (LAW_CONFIG[key] && LAW_CONFIG[key].data) {
                  allQuestions = [...allQuestions, ...LAW_CONFIG[key].data];
                }
              });

              // 2. 30문제 랜덤 추출
              const shuffled = allQuestions.sort(() => Math.random() - 0.5).slice(0, 30);

              // 3. 하트 7개 설정
              setSelectedLaw({ 
                title: "도전! 랜덤 법률", 
                id: 'challenge', 
                maxLives: 7 
              });
              
              // 4. 문제 주입 및 화면 이동
              if (setSelectedStage) {
                setSelectedStage({
                  id: 'random-challenge',
                  title: '랜덤 도전',
                  questions: shuffled,
                  sessionKey: Date.now()
                });
              }

              setGameModeType('challenge');
              setView('game');
            }} 
            className="w-full bg-gradient-to-r from-red-950 to-red-900 border border-red-500/60 hover:from-red-900 hover:to-red-800 p-4 rounded-xl shadow-xl transition relative overflow-hidden group"
          >
            <div className="absolute -top-4 -right-4 p-4 opacity-10 group-hover:opacity-20 transition transform group-hover:rotate-12">
              <Zap className="w-24 h-24 text-white" />
            </div>
            <div className="relative z-10 flex flex-col items-center">
              <h3 className="text-lg font-bold text-white flex items-center mb-1">
                <Zap className="w-5 h-5 mr-2 text-yellow-300 fill-yellow-300 animate-pulse" /> 도전! 랜덤 법률
              </h3>
              <span className="bg-red-600/80 text-white text-[10px] font-bold px-2 py-0.5 rounded-full mb-2 shadow">전 범위 30문제 랜덤 / 하트 7개</span>
            </div>
          </button>
        </div>
        
        <div className="flex flex-col md:flex-row items-center space-y-3 md:space-y-0 md:space-x-4 text-xs text-slate-500 pt-4 w-full justify-center">
          <button onClick={() => setView('odaptong')} className="bg-amber-100 text-slate-900 font-bold py-2 px-6 rounded-full shadow-lg hover:shadow-xl hover:bg-white transform hover:scale-105 transition border-2 border-amber-300 flex items-center">
            <Brain className="w-4 h-4 mr-2" /> 오답통 바로가기
          </button>
          {isAdmin && <button onClick={() => setView('admin')} className="hover:text-indigo-400 underline">관리자 메뉴</button>}
        </div>
        
        <div className="pt-2">
          <button onClick={() => setShowFeedbackModal(true)} className="flex items-center text-slate-500 hover:text-indigo-400 text-xs transition underline">
            <MessageCircle className="w-3 h-3 mr-1" /> 오타 제보 및 개선사항 건의하기
          </button>
        </div>
      </div>
    </div>
  );
}